import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { CloudUpload } from "@mui/icons-material";

import { uploadEntries } from "../../../actions/entry";

import { useDialogState } from "../../../hooks/useDialogState";
import { ProgressButton } from "../forms/fields/ProgressButton";
import { FileButton } from "../forms/fields/FileButton";
import { UploadDialog } from "../../util/uploadDialog";
import { T } from "../../util/t";

export const UploadEntriesWidget = ({
    hasEntries,
    eventDivisionId,
    isTeams,
}) => {
    const [uploading, setUploading] = useState(false);
    const [dialogOpen, openDialog, closeDialog] = useDialogState();
    const [selectedFile, setSelectedFile] = useState();

    const uploadFinished = useCallback(() => {
        setUploading(false);
        closeDialog();
    }, []);

    const dispatch = useDispatch();
    const doFileUpload = useCallback((file, overwrite) => {
        setUploading(true);
        return dispatch(
            uploadEntries(eventDivisionId, file, overwrite, isTeams),
        ).then(uploadFinished, uploadFinished);
    }, []);

    const onChange = useCallback(
        (e) => {
            setSelectedFile(e.target.files[0]);
            return hasEntries
                ? openDialog(true)
                : doFileUpload(e.target.files[0], true);
        },
        [hasEntries],
    );

    return (
        <>
            <FileButton
                accept="text/csv"
                onChange={onChange}
                variant="outlined"
                size="small"
                Component={ProgressButton}
                inProgress={uploading}
                disabled={dialogOpen || uploading}
                startIcon={<CloudUpload fontSize="small" />}
            >
                <T>{isTeams ? "Import teams" : "Import athletes"}</T>
            </FileButton>

            <UploadDialog
                title="Add to the existing table?"
                description="import_dialog_description"
                open={dialogOpen}
                importFile={selectedFile}
                closeImportDialog={closeDialog}
                doFileUpload={doFileUpload}
            />
        </>
    );
};
